import React from 'react'
import { useTranslation } from 'react-i18next'

interface TicketTransferDetailProps {
  type: string
  assignDate: string
}

function TicketTransferDetail(props: TicketTransferDetailProps): JSX.Element {
  const { type, assignDate } = props
  const { t } = useTranslation('ticket')

  const base = 'f-ticket-transfer-modal'

  return (
    <div className={`${base}__content-detail`}>
      <div className={`${base}__content-detail-item`}>
        <span className={`${base}__content-detail-title`}>
          {t('type.title')}
        </span>
        <span className={`${base}__content-detail-value`}>{type}</span>
      </div>

      <div className={`${base}__content-detail-item`}>
        <span className={`${base}__content-detail-title`}>
          {t('requestDate.title')}
        </span>
        <span className={`${base}__content-detail-value`}>{assignDate}</span>
      </div>
    </div>
  )
}

export default TicketTransferDetail
